export default __webpack_public_path__ + "static/media/audioPlayIcon.74359e26.svg";